
const HomeUI = () => {
    return (
        <h1>HomeUI</h1>
    )
}

export default HomeUI;
